import { render, staticRenderFns } from "./application-create-form.vue?vue&type=template&id=19e13710&scoped=true"
import script from "./application-create-form.vue?vue&type=script&lang=js"
export * from "./application-create-form.vue?vue&type=script&lang=js"
import style0 from "./application-create-form.vue?vue&type=style&index=0&id=19e13710&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e13710",
  null
  
)

export default component.exports